import React from 'react';
import PropTypes from 'prop-types';
import {Box, Flex, Heading} from 'rebass'
import {Tabs} from 'reakit'
import styled from 'styled-components';
import {boxShadow} from "styled-system";
import {ActiveTabCircle, InactiveTabCircle, TabWrapper} from "./styles";
import {DesktopBox, MobileBox, TabHeader} from "../../components/Base";

const DescriptionWrapper = styled(Box)`
	min-height: 150px;
	.ql-editor {
		min-height: 175px;
		max-height: 175px;
		overflow: auto;
		pointer-events: none;
	}
	.ql-toolbar.ql-snow {
		border: none;
	}
	.ql-container.ql-snow {
		border: none;
	}
`;

export const Sidebar = styled(Box)`
	min-width: 310px;
	max-width: 350px;
	height: calc(99vh - 468px);
	overflow: auto;

	${boxShadow}
	//margin-top: -5px;
	@media(max-width: 700px) {
		height: 50px;
		width: 100vw;
		display: flex; /* [1] */
  flex-wrap: nowrap; /* [1] */
  overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
	}
`;

const Scroller = styled(Box)`
	width: 100vw;
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
	}

	> ul {
		height: 50px;
		width: unset;
		flex-wrap: nowrap;
		margin: 0 auto;

		li {
			flex: unset;
			flex-shrink: 0;
			padding: 0 10px 0 10px;

			&:first-child {
				padding-left: 20px;
			}
			
			&:last-child {
				padding-right: 20px;
			}
		}
	}
`;

Sidebar.defaultProps = {
	boxShadow: '0 3px 6px rgba(0, 0, 0, .16)',
	flexDirection: 'column',
	flexWrap: 'wrap'
};

const CalendarTabs = props => {
	const {tothData, formattedDate} = props;
	const filteredDataToday = tothData.filter(data => data.id === formattedDate);
	const filteredData = filteredDataToday[0] == null ? [] : filteredDataToday[0]['data'].filter(data => data.schedules.some(schedule => schedule.active));

	return (
		<Tabs.Container background={'white'}>
			{(tabs) =>
				(
					<Flex flexDirection={['column', 'row']} flexWrap={'wrap'}>

						<MobileBox >
							<Scroller>
								<Tabs alignItems={'center'}>
										{/* {tothSchedule.map(item => (
											<Tabs.Tab tab={item.id} {...tabs}>
												<TabHeader title={item.category}/>
											</Tabs.Tab>
										))} */}

									{filteredData.map((item, x) => (
										<Tabs.Tab key={`${item.name} + ${x}`} tab={`${item.name} + ${x}`} {...tabs}>												<TabHeader title={item.category} />
											<TabHeader title={item.name} />
										</Tabs.Tab>
									))}
								</Tabs>
							</Scroller>

						</MobileBox>
						<DesktopBox>

						<Sidebar>

								<Tabs boxShadow={'none'}>


									<Flex flexDirection={['row', 'column']} flexWrap={'wrap'} alignItems={'left'}
									      justifyCotent={'space-evenly'}>
										{/*
										<Tabs.Tab tab={'school-schedule'} {...tabs} >
											<Flex pl={'10px'} my={3} width={[1 / 4, '100%']}>
												<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
													{tabs.current === 0 ? <ActiveTabCircle/> : <InactiveTabCircle/>}
												</Flex>
												<Box pr={3}>
													<Heading lineHeight={0.8} as={'h3'}>School Schedule</Heading>
												</Box>
											</Flex>
										</Tabs.Tab>
										*/}
										{/* {tothSchedule.map((item, x) => (
											<Tabs.Tab key={item.id} tab={item.id} {...tabs}>
												<Flex pl={'10px'} my={3} width={[1 / 4, '100%']}>
													<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
														{tabs.current === x + 1 ? <ActiveTabCircle/> : <InactiveTabCircle/>}
													</Flex>
													<Box pr={3}>
														<Heading lineHeight={0.8} as={'h3'}>{item.category}</Heading>
													</Box>
												</Flex>
											</Tabs.Tab>
										))} */}

										{filteredData.map((item, x) => (
											<Tabs.Tab key={`${item.name} + ${x}`} tab={`${item.name} + ${x}`} {...tabs}>
												<Flex pl={'10px'} my={3} width={[1 / 4, '100%']}>
													<Flex flexWrap={'wrap'} flexDirection={'column'} justifyContent={'center'} px={3}>
														{tabs.current === x ? <ActiveTabCircle /> : <InactiveTabCircle />}
													</Flex>
													<Box pr={3}>
														<Heading lineHeight={0.8} as={'h3'}>{item.name}</Heading>
													</Box>
												</Flex>
											</Tabs.Tab>
										))}

									</Flex>
								</Tabs>
							</Sidebar>

						</DesktopBox>
						<TabWrapper mt={[4, 0]}>


							{/* {tothSchedule.map((item, x) => (
								<Tabs.Panel tab={item.id} {...tabs} width={'100%'}>
									<Flex justifyContent={'center'} width={1} p={3} flexDirection={'column'} flexWrap={'wrap'}>
										{tothSchedule[x].details.map(item => (
												<Flex justifyContent={'center'} flexDirection={'column'} flexWrap={'wrap'}>
													<DescriptionWrapper width={[1]}>
														<Box width={1}
														     dangerouslySetInnerHTML={{__html: item.details}}/>

													</DescriptionWrapper>
												</Flex>
											)
										)}
									</Flex>
								</Tabs.Panel>
							))} */}

							{filteredData.map((item, x) => (
								<Tabs.Panel key={`${item.name} + ${x}`} tab={`${item.name} + ${x}`} {...tabs} width={'100%'}>
									<Flex justifyContent={'center'} width={1} p={3} flexDirection={'column'} flexWrap={'wrap'}>
										{item.schedules.filter(schedule => schedule.active).map(obj => (
											<Flex justifyContent={'center'} flexDirection={'column'} flexWrap={'wrap'}>
												<DescriptionWrapper width={[1]}>
													{/* <Box width={1}>{obj.details}</Box> */}
													<Box width={1} dangerouslySetInnerHTML={{ __html: obj.details }} />
												</DescriptionWrapper>
											</Flex>
										))}
									</Flex>
								</Tabs.Panel>
							))}
							{/*
							
							<Tabs.Panel tab={'school-schedule'} {...tabs} width={'100%'}>
								<Flex justifyContent={'center'} width={1} p={3} flexDirection={'column'} flexWrap={'wrap'}>
									{schoolSchedule.map((event, x) =>
										<Flex justifyContent={'center'} py={2} key={x} flexDirection={'column'}>
											<Box width={1}><Text
												textAlign={'center'}>{event.location || event.description || event.summary}</Text></Box>
											<Box width={1}>
												<MetaText
													textAlign={'center'}>{event.startDate} {event.endDate && `- ${event.endDate}`}</MetaText>
											</Box>
										</Flex>
									)}

								</Flex>
							</Tabs.Panel>
							*/}
						</TabWrapper>



					</Flex>

				)}
		</Tabs.Container>
	);
};

CalendarTabs.propTypes = {
	categories: PropTypes.array,
	schoolSchedule: PropTypes.array,
	tothSchedule: PropTypes.array,
};

CalendarTabs.defaultProps = {
	categories: [],
	schoolSchedule: [],
	tothSchedule: []
};

export default CalendarTabs;
